import { render } from "./edit.vue?vue&type=template&id=32316006"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/people/profile/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32316006"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32316006', __exports__)) {
    console.log('reload')
    api.reload('32316006', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=32316006", () => {
    console.log('re-render')
    api.rerender('32316006', render)
  })

}


export default __exports__